module.exports = new __parcel__URL__("vt_assets.8b06ddb1.png").toString();